import { Reducer } from "redux";
import { CALL_API } from "../helpers/middleware/api";
import createRequestTypes from "../helpers/createRequestTypes";

const AUTH_NONCE_REQUEST = createRequestTypes("AUTH_NONCE_REQUEST");

export const authWithNonce = (body: any) => ({
  [CALL_API]: {
    types: AUTH_NONCE_REQUEST,
    endpoint: "/api/v2.0/users/_authenticate_by_token",
    noJson: true,
    options: {
      credentials: "same-origin",
      method: "POST",
      body: JSON.stringify(body)
    }
  }
});

export interface LoginNonceRequestState {
  requested: boolean;
  requesting: boolean;
  success: boolean;
  error: string;
}

const initialState: LoginNonceRequestState = {
  requested: false,
  requesting: false,
  success: false,
  error: null
};

const reducer: Reducer<LoginNonceRequestState> = (
  state = initialState,
  action
): LoginNonceRequestState => {
  switch (action.type) {
    case AUTH_NONCE_REQUEST.REQUEST:
      return { requested: true, requesting: true, success: false, error: null };
    case AUTH_NONCE_REQUEST.SUCCESS:
      return { requested: true, requesting: false, success: true, error: null };
    case AUTH_NONCE_REQUEST.FAILURE:
      return {
        requested: true,
        requesting: false,
        success: false,
        error: action.error.errors[0]
      };
    case "AUTH_NONCE_REQUEST_RESET":
      return initialState;
    default:
      return state;
  }
};

export default reducer;
